const getNavHeight = (infoHeight, logoHeight, linkHeight, navLayout, isScrolling) => {
  let navHeight = infoHeight + logoHeight + (navLayout === 'center' ? 40 : isScrolling ? 8 : 80);
  navHeight =
    navLayout === 'center' ? navHeight + linkHeight + 10 : navLayout === 'divided' ? navHeight + 9 : navHeight;

  return navHeight;
};

export default getNavHeight;
